define((require) => {
    "use strict";

    const $             = require("jquery");
    const Browser       = require("shared/services/Browser");
    const Configuration = require("shared/services/Configuration");
    const Login         = require("security/Login");
    const RestApi       = require("shared/services/RestApi");
    const Window        = require("shared/services/Window");

    const ZENDESK_URL = Configuration.communityBaseUrl;

    /**
     * Contains functions related to Zendesk.
     *
     * @see https://support.zendesk.com/entries/23675367-Setting-up-single-sign-on-with-JWT-JSON-Web-Token-
     * @class ZendeskUtil
     */
    const ZendeskUtil = {

        /**
         * Looks up the Zendesk token, aka. the JSON Web Token.
         *
         * @return {Promise} A promise object that resolves then the request completes.
         */
        getToken() {
            return $.ajax({
                url: `${RestApi.API_URL}/users/zendeskToken`,
                type: "GET",
                dataType: "json"
            });
        },

        /**
         * @private
         * @static
         *
         * Constructs the proper community URL given the Zendesk token.
         *
         * @param  {String} token    The Zendesk token, see #getToken
         * @param  {String} returnTo Optional URL to navigate to once the SSO process has been successful.
         * @return {String}          The community URL.
         */
        constructCommunityURL(token, returnTo) {
            const url = `${ZENDESK_URL}/access/jwt?jwt=${token}`;
            return returnTo ? `${url}&return_to=${returnTo}` : url;
        },

        /**
         * Logs the user in to Zendesk using SSO.
         */
        login(authController) {
            // Attempt login as persisted user
            Login.loginPersistedUser()
                // On failure, login using login form
                .then(null, authController.showLoginForm.bind(authController))
                .then(this.getToken)
                .done((data) => {
                    const queryParams = Browser.getQueryParameters();
                    window.location.href = this.constructCommunityURL(data.zendeskToken, queryParams.return_to);
                });
        },

        /**
         * Opens a link to the community, trying to link to the specific page if possible.
         *
         * @param {String} [article] The article code; can be falsey.
         */
        openCommunity(article) {
            let url = ZENDESK_URL;
            if (url) {
                if (article) {
                    url += `/hc/en-us/articles/${article}`;
                }
                // Open named window...
                Window.open(url, "zmags_creator_community");
            }
        }

    };

    return ZendeskUtil;
});



// WEBPACK FOOTER //
// ./src/editor/util/ZendeskUtil.js